<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiWorkflow: [],
      dataFromApiWorkflowTipo: [],
      dataFromApiUsuario: [],
      workflowtipoid: null,
      loadingWorkflowTipo: false,
      loadingWorkflow: false,
      loadingUsuario: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if (!newValue.Workflow) {
            this.dataForm.Workflow = { workflowtipoid: null };
          }
          this.fetchDataFromWorkflow();
        }
      },
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromWorkflow() {
      try {
        this.loadingWorkflow = true;
        const workflowTipoId = this.dataForm?.Workflow?.workflowtipoid;
        if (!workflowTipoId) {
          this.dataFromApiWorkflow = [];
          return;
        }
        const response = await axios.get(`/workflow/findByTipoWorkflow/${workflowTipoId}`);
        this.dataFromApiWorkflow = response.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loadingWorkflow = false;
      }
    },
    async fetchDataFromWorkflowTipo() {
      try {
        this.loadingWorkflowTipo = true;
        const response = await axios.get('/workflow-tipo');
        this.dataFromApiWorkflowTipo = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loadingWorkflowTipo = false;
      }
    },
    async limpardados() {
      this.dataForm.workflowid = null,
      this.dataForm.workflowiddestino = null;
    },
    async fetchDataFromUsuario() {
      try {
        this.loadingUsuario = true;
        const response = await axios.get('/usuarios/findAll?perPage=500000');
        this.dataFromApiUsuario = response.data.data.map((user) => ({
          value: user.usuarioid,
          text: user.usuario_nome,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loadingUsuario = false;
      }
    },
    onModalShow() {
      this.fetchDataFromWorkflowTipo();
      this.fetchDataFromUsuario();
      if (this.dataForm && !this.dataForm.Workflow) {
        this.dataForm.Workflow = { workflowtipoid: null };
      }
      if (this.dataForm && this.dataForm.Workflow) {
        this.fetchDataFromWorkflow();
      }
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="md" :id="idModal" :title="titleModal"
    :ok="dataForm.isDefault || dataForm.workflowdescricao === ''" :ok-title="labelBtnOk" ok-variant="success"
    cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok="validateForm"
    @cancel="$emit('cancel')" @close="$emit('cancel')">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Tipo Workflow" label-for="workflowid">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">

                <b-form-select v-model="dataForm.Workflow.workflowtipoid" id="workflowtipoid"
                  :state="errors.length > 0 ? false : null" :options="dataFromApiWorkflowTipo"
                  value-field="workflowtipoid" text-field="workflowtipodescricao"
                  placeholder="Selecione uma workflow tipo" @change="fetchDataFromWorkflow()"
                  :disabled="loadingWorkflowTipo">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ loadingWorkflowTipo ? 'Carregando...' : 'Selecione uma workflow tipo' }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Workflow" label-for="workflowid">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-select v-model="dataForm.workflowid" id="workflowid" :state="errors.length > 0 ? false : null"
                  :options="dataFromApiWorkflow" value-field="workflowid" text-field="workflowdescricao"
                  placeholder="Selecione uma workflow"
                  :disabled="dataForm.Workflow.workflowtipoid === null || loadingWorkflow">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ loadingWorkflow ? 'Carregando...' : 'Selecione uma workflow' }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Funcionario" label-for="funcionarioid">
              <validation-provider #default="{ errors }" name="Funcionário" rules="required">
                <v-select
                  v-model="dataForm.funcionarioid"
                  :options="dataFromApiUsuario"
                  :reduce="user => user.value"
                  label="text"
                  placeholder="Selecione um usuario"
                  :disabled="loadingUsuario"
                  :class="{'is-invalid': errors.length > 0}"
                  id="funcionarioid"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
